import { Box } from 'grommet';
import { useEffect, useState } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { GoogleMap } from '..';
import { AutocompleteCustom } from './AutocompleteCustom';
import { useProjectStore } from '../../../context';
import { getAddressObject, IAddress, stateAbbreviations } from '../../../utils/decodeGoogle';
import { toast } from 'react-toastify';

interface ILocationProps {
    place?: IAddress
    id: string;
    updatePlace: (place: IAddress) => void;
}

export const Location = (props: ILocationProps) => {
  const { place, id, updatePlace } = props;
  const { street_address, city, state, zip, lat, lng } = place ?? {};
  const projectStore = useProjectStore();
  const [apiKey, setApiKey] = useState<string | undefined>(undefined);

  useEffect(() => {
    const getApiKey = async () => {
      const apiKey = await projectStore.getMapApiKey();
      setApiKey(apiKey);
    };
    getApiKey();
  }, []);

  const extractAddress = async (place: google.maps.places.Place) => {
    if (!place.addressComponents) {
      toast.error('No address components found in the selected place.');
      return;
    }
    const address = getAddressObject(place.addressComponents);
    address.lat = place.location?.lat();
    address.lng = place.location?.lng();
    if (!address.state) {
      toast.error('State is required to update the location.');
      return;
    }
    address.state = stateAbbreviations[address.state.toLowerCase()];
    updatePlace(address);
  };

  return (
    <Box direction="column" pad="small">
      {apiKey && (
        <APIProvider apiKey={apiKey} libraries={['places', 'marker']}>
          <Box pad="small" gap='small'>
            <Box direction="row" align="center" gap="small">
              <AutocompleteCustom
                onPlaceSelect={(place) => {
                  if (place) {
                    extractAddress(place);
                  }
                }}
                defaultValue={
                  street_address !== ''
                    ? `${street_address} ${city} ${state} ${zip}`
                    : undefined
                }
              />
            </Box>
            {!!(lat && lng) && apiKey && (
              <GoogleMap
                apiKey={apiKey}
                position={{ lat: lat, lng: lng }}
                zoom={10}
                id={id || 'new'}
              />
            )}
          </Box>
        </APIProvider>
      )}
    </Box>
  );};

